import { z } from "zod";

export const copyWorkplaceFormSchema = z.object({
  sourceWorkplace: z.object({ name: z.string(), userId: z.string() }),
  name: z.string().min(1, { message: "Please enter a workplace name." }),
  email: z
    .union([z.string().email("Please enter a valid email address"), z.literal("")])
    .optional(),
  phone: z.string().optional(),
  addressObject: z
    .object(
      {
        address: z.object(
          {
            streetNumber: z.string().optional(),
            streetName: z.string().optional(),
            city: z.string().optional(),
            region: z.string().optional(),
            state: z.string().optional(),
            stateCode: z.string().optional(),
            country: z.string().optional(),
            countryCode: z.string().optional(),
            postalCode: z.string().optional(),
            formatted: z.string({
              required_error: "Please enter the workplace's address.",
              invalid_type_error: "Please enter a valid address.",
            }),
          },
          {
            required_error: "Please enter the workplace's address.",
            invalid_type_error: "Please enter a valid address.",
          }
        ),

        coordinates: z.object({
          latitude: z.number(),
          longitude: z.number(),
        }),
      },

      {
        required_error: "Please enter the workplace's address.",
        invalid_type_error: "Please enter a valid address.",
      }
    )

    .refine(
      (data) => {
        const keysToCheck = [
          "city",
          "country",
          "countryCode",
          "formatted",
          "postalCode",
          "state",
          "stateCode",
        ];

        // @ts-expect-error TODO(typecheck-unify): TS7053 Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ streetNumber?: string | undefined;
        const hasUndefinedValue = keysToCheck.some((key) => data.address[key] === undefined);

        if (hasUndefinedValue) {
          return false;
        }
        return true;
      },
      {
        message: "Please enter a valid workplace address with city and postal code.",
      }
    )
    .optional(),
  meta: z.object({
    copy: z.object({
      notes: z.boolean(),
      pricingParameters: z.boolean(),
    }),
    isChow: z.boolean(),
  }),
});
export type CopyWorkplaceForm = z.infer<typeof copyWorkplaceFormSchema>;
